<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    <i class="fas fa-chart-line mr-2"></i>Laporan &amp; Analytics
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <button @click="loadData" class="btn btn-sm btn-primary" :disabled="isLoading">
                                <i class="fas fa-sync-alt" :class="{ 'fa-spin': isLoading }"></i> Refresh
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading State -->
            <div v-if="isLoading" class="row">
                <div class="col-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <center>
                            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p class="mt-3 text-muted">Memuat data laporan...</p>
                        </center>
                    </div>
                </div>
            </div>

            <!-- Main Content -->
            <div v-else class="row">
                <!-- User Statistics Section -->
                <div class="col-12 mb-4">
                    <h5 class="section-title mb-3">
                        <i class="fas fa-users mr-2"></i>Statistik Pengguna
                    </h5>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-primary">
                        <div class="stat-card-icon">
                            <i class="fas fa-users"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatNumber(analytics.users_count || 0) }}</h2>
                            <p class="stat-card-label">Total User</p>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-success">
                        <div class="stat-card-icon">
                            <i class="fas fa-user-check"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatNumber(analytics.users_subsribers_count || 0) }}</h2>
                            <p class="stat-card-label">User Berlangganan</p>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-info">
                        <div class="stat-card-icon">
                            <i class="fas fa-user-clock"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatNumber(analytics.users_trial_count || 0) }}</h2>
                            <p class="stat-card-label">User Trial</p>
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-warning">
                        <div class="stat-card-icon">
                            <i class="fas fa-user-slash"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatNumber(analytics.users_inactive_count || 0) }}</h2>
                            <p class="stat-card-label">User Tidak Aktif</p>
                        </div>
                    </div>
                </div>

                <!-- Member Paid Section -->
                <div class="col-12 mb-4 mt-4">
                    <h5 class="section-title mb-3">
                        <i class="fas fa-money-bill-wave mr-2"></i>Member Berbayar
                    </h5>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-12 mb-4">
                    <div class="stat-card stat-card-gradient-1">
                        <div class="stat-card-icon">
                            <i class="fas fa-building"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">
                                {{ formatNumber((analytics.users_agency && analytics.users_agency.total_records) || 0) }}
                            </h2>
                            <p class="stat-card-label">Member Paid Agency</p>
                            <p class="stat-card-subvalue">{{ formatRupiah((analytics.users_agency && analytics.users_agency.total_price) || 0) }}</p>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-12 mb-4">
                    <div class="stat-card stat-card-gradient-2">
                        <div class="stat-card-icon">
                            <i class="fas fa-user-tie"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">
                                {{ formatNumber((analytics.users_non_agency && analytics.users_non_agency.total_records) || 0) }}
                            </h2>
                            <p class="stat-card-label">Member Paid non-Agency</p>
                            <p class="stat-card-subvalue">{{ formatRupiah((analytics.users_non_agency && analytics.users_non_agency.total_price) || 0) }}</p>
                        </div>
                    </div>
                </div>

                <!-- Financial Statistics -->
                <div class="col-12 mb-4 mt-4">
                    <h5 class="section-title mb-3">
                        <i class="fas fa-wallet mr-2"></i>Statistik Keuangan
                    </h5>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-danger">
                        <div class="stat-card-icon">
                            <i class="fas fa-money-bill-transfer"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatRupiah(analytics.withdraw_total || 0) }}</h2>
                            <p class="stat-card-label">Total Withdraw</p>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-orange">
                        <div class="stat-card-icon">
                            <i class="fas fa-hand-holding-usd"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatRupiah(analytics.user_total_withdrawable_balance || 0) }}</h2>
                            <p class="stat-card-label">Total Withdrawable</p>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
                    <div class="stat-card stat-card-green">
                        <div class="stat-card-icon">
                            <i class="fas fa-coins"></i>
                        </div>
                        <div class="stat-card-content">
                            <h2 class="stat-card-value">{{ formatRupiah(analytics.user_total_balance || 0) }}</h2>
                            <p class="stat-card-label">Total Saldo User</p>
                        </div>
                    </div>
                </div>

                <!-- Active users per package -->
                <div class="col-12 mb-4 mt-4">
                    <h5 class="section-title mb-3">
                        <i class="fas fa-box-open mr-2"></i>User Aktif per Paket
                    </h5>
                </div>

                <div class="col-12 mb-4">
                    <div class="userDatatable global-shadow border bg-white radius-xl w-100 mb-30 overflow-hidden">
                        <div v-if="loadError" class="p-30 text-center text-danger">
                            <i class="fas fa-exclamation-circle mr-2"></i>{{ loadError }}
                        </div>
                        <div v-else-if="!packageRows.length" class="p-30 text-center text-muted">
                            Tidak ada paket dengan user aktif saat ini.
                        </div>
                        <div v-else class="table-responsive">
                            <table class="table mb-0 laporan-package-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nama Paket</th>
                                        <th class="text-right">Harga</th>
                                        <th>Visibilitas</th>
                                        <th class="text-right">Aktif</th>
                                        <th class="text-right">Berbayar</th>
                                        <th class="text-right">Trial</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in packageRows" :key="row.id">
                                        <td>{{ row.id }}</td>
                                        <td>{{ row.name }}</td>
                                        <td class="text-right">{{ formatRupiah(row.price || 0) }}</td>
                                        <td>
                                            <span
                                                class="badge badge-pill"
                                                :class="row.hide ? 'badge-secondary' : 'badge-success'"
                                            >
                                                {{ row.hide ? 'Tersembunyi' : 'Dijual' }}
                                            </span>
                                        </td>
                                        <td class="text-right font-weight-bold">{{ formatNumber(row.active_count || 0) }}</td>
                                        <td class="text-right">{{ formatNumber(row.paid_active || 0) }}</td>
                                        <td class="text-right">{{ formatNumber(row.trial_active || 0) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p v-if="packageRows.length" class="text-muted small px-30 pb-20 mb-0">
                            {{ packageRows.length }} paket dengan user aktif (expired_at ≥ sekarang). Data sama dengan ringkasan di atas, cache ~5 menit.
                        </p>
                    </div>
                </div>

                <!-- Google Analytics Section -->
                <div class="col-12 mt-4">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="mb-2">
                                    <i class="fas fa-chart-line text-warning mr-2"></i>Google Analytics
                                </h5>
                                <p class="text-muted mb-0">Akses dashboard analytics untuk melihat data lebih detail</p>
                            </div>
                            <a href="https://analytics.google.com/analytics/web/#/p276082162/reports/reportinghub"
                                class="btn btn-warning btn-lg" target="_blank">
                                <i class="fas fa-external-link-alt mr-2"></i>Buka Google Analytics
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: true,
            loadError: '',
            analytics: {
                users_count: 0,
                users_subsribers_count: 0,
                users_trial_count: 0,
                users_inactive_count: 0,
                users_agency: { total_records: 0, total_price: 0 },
                users_non_agency: { total_records: 0, total_price: 0 },
                withdraw_total: 0,
                user_total_withdrawable_balance: 0,
                user_total_balance: 0,
                packages_active: []
            }
        }
    },
    computed: {
        packageRows() {
            return this.analytics.packages_active || []
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        async loadData() {
            this.isLoading = true
            this.loadError = ''
            try {
                let analytics = await this.$store.dispatch("admin_analytics")
                this.analytics = analytics.data.data || this.analytics
                if (!this.analytics.packages_active) {
                    this.analytics.packages_active = []
                }
            } catch (err) {
                const errorMessage = (err.response && err.response.data && err.response.data.message) || "Gagal memuat data laporan"
                this.loadError = errorMessage
                this.$toast.error(errorMessage)
            } finally {
                this.isLoading = false
            }
        },
        formatNumber(numb) {
            if (!numb && numb !== 0) return '0'
            const format = numb.toString().split('').reverse().join('');
            const convert = format.match(/\d{1,3}/g);
            return convert ? convert.join('.').split('').reverse().join('') : '0'
        },
        formatRupiah(numb) {
            if (!numb && numb !== 0) return 'Rp 0'
            const format = numb.toString().split('').reverse().join('');
            const convert = format.match(/\d{1,3}/g);
            const rupiah = 'Rp ' + (convert ? convert.join('.').split('').reverse().join('') : '0')
            return rupiah
        },
    }
}
</script>

<style scoped>
.section-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.25rem;
    border-bottom: 2px solid #e9ecef;
    padding-bottom: 0.5rem;
}

.stat-card {
    background: white;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
}

.stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    transition: width 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.stat-card:hover::before {
    width: 100%;
    opacity: 0.1;
}

.stat-card-icon {
    width: 70px;
    height: 70px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: white;
    flex-shrink: 0;
    transition: all 0.3s ease;
}

.stat-card:hover .stat-card-icon {
    transform: scale(1.1) rotate(5deg);
}

.stat-card-content {
    flex: 1;
}

.stat-card-value {
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
    color: #2c3e50;
    line-height: 1.2;
}

.stat-card-label {
    font-size: 0.9rem;
    color: #6c757d;
    margin: 5px 0 0 0;
    font-weight: 500;
}

.stat-card-subvalue {
    font-size: 0.85rem;
    color: #28a745;
    margin: 5px 0 0 0;
    font-weight: 600;
}

/* Color Themes */
.stat-card-primary {
    border-left: 4px solid #007bff;
}

.stat-card-primary .stat-card-icon {
    background: #007bff;
}

.stat-card-success {
    border-left: 4px solid #28a745;
}

.stat-card-success .stat-card-icon {
    background: #28a745;
}

.stat-card-info {
    border-left: 4px solid #17a2b8;
}

.stat-card-info .stat-card-icon {
    background: #17a2b8;
}

.stat-card-warning {
    border-left: 4px solid #ffc107;
}

.stat-card-warning .stat-card-icon {
    background: #ffc107;
}

.stat-card-danger {
    border-left: 4px solid #dc3545;
}

.stat-card-danger .stat-card-icon {
    background: #dc3545;
}

.stat-card-orange {
    border-left: 4px solid #fd7e14;
}

.stat-card-orange .stat-card-icon {
    background: #fd7e14;
}

.stat-card-green {
    border-left: 4px solid #198754;
}

.stat-card-green .stat-card-icon {
    background: #198754;
}

.stat-card-gradient-1 {
    border-left: 4px solid #667eea;
    background: rgba(102, 126, 234, 0.05);
}

.stat-card-gradient-1 .stat-card-icon {
    background: #667eea;
}

.stat-card-gradient-2 {
    border-left: 4px solid #f093fb;
    background: rgba(240, 147, 251, 0.05);
}

.stat-card-gradient-2 .stat-card-icon {
    background: #f093fb;
}

/* Responsive */
@media (max-width: 768px) {
    .stat-card {
        padding: 20px;
    }

    .stat-card-icon {
        width: 60px;
        height: 60px;
        font-size: 24px;
    }

    .stat-card-value {
        font-size: 1.5rem;
    }

    .section-title {
        font-size: 1.1rem;
    }
}

.action-btn {
    display: flex;
    align-items: center;
    gap: 10px;
}

.laporan-package-table thead th {
    border-top: none;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: #6c757d;
    white-space: nowrap;
}

.laporan-package-table tbody td {
    vertical-align: middle;
}
</style>
